<template>
    <!-- Filter Form --> 
    <!-- <div class="w3-card w3-round w3-white w3-hide-small"> -->
    <div class="w3-card w3-round w3-white">
        <div class="w3-container">
            <div class="w3-left-align">
                <div v-if="!isAuthenticated && user">
                    Statements that {{userFirstName}}:<br/>
                    <input @change="toggleCreatedByUser()" type="checkbox" id="createdByUser" v-model="statementSearchForm.createdByUser">
                    <label for="createdByUser"> Created </label>
                    <br />
                    <input @change="toggleJybedByUser()" type="checkbox" id="jybedByUser" v-model="statementSearchForm.jybedByUser">
                    <label for="jybedByUser"> Jybed</label>
                    <br/>
                </div>
                <div v-if="isAuthenticated">
                    Created by:<br/>
                    <input @change="toggleCreatedByMe()" type="checkbox" id="createdByMe" v-model="statementSearchForm.createdByMe">
                    <label for="createdByUser"> Me </label>
                    <span v-if="userFeed">
                        <input @change="toggleCreatedByUser()" type="checkbox" id="createdByUser" v-model="statementSearchForm.createdByUser">
                        <label for="createdByUser"> {{userFirstName}} </label>
                    </span>
                    <input @change="toggleCreatedByFollowing()" type="checkbox" id="createdByFollowing" v-model="statementSearchForm.createdByFollowing">
                    <label for="createdByFollowing"> Trustees</label>
                    <br/>
                    <br/>
                    Jybed by:<br/>
                    <input @change="toggleJybedByMe()" type="checkbox" id="jybedByMe" v-model="statementSearchForm.jybedByMe">
                    <label for="jybedByMe"> Me </label>
                    <span v-if="userFeed">
                        <input @change="toggleJybedByUser()" type="checkbox" id="jybedByUser" v-model="statementSearchForm.jybedByUser">
                        <label for="jybedByUser"> {{userFirstName}} </label>
                    </span>
                    <input @change="toggleJybedByFollowing()" type="checkbox" id="jybedByFollowing" v-model="statementSearchForm.jybedByFollowing">
                    <label for="jybedByFollowing"> Trustees</label>
                    <br/>
                    <br/>
                    Statements that I:<br/>
                    <input @change="toggleConsideredByMe()" type="checkbox" id="consideredByMe" v-model="statementSearchForm.consideredByMe">
                    <label for="consideredByMe"> Considered </label>
                    <input @change="toggleIgnoredByMe()" type="checkbox" id="ignoredByMe" v-model="statementSearchForm.ignoredByMe">
                    <label for="ignoredByMe"> Ignored</label>
                    <br/>
                    <input @change="toggleNotReactedByMe()" type="checkbox" id="notReactedByMe" v-model="statementSearchForm.notReactedByMe">
                    <label for="notReactedByMe"> Have Not Reacted To</label>
                    <br />
                </div>
                <br/>
                <input @keyup.enter="addSearchTag()" type="text" name="tags" placeholder="TAG" v-model="statementSearchForm.tag" class="w3-margin-bottom">
                <span v-for="(tag) in statementSearchForm.tags" class="w3-tag w3-medium w3-theme-d5 w3-margin-right w3-margin-bottom"> 
                    {{tag}} &nbsp;<a @click="removeSearchTag(tag)" type="button" class="w3-theme-d5"> X</a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
  import StatementSearch from './StatementSearch.ts'
  export default StatementSearch
</script>
